import React from "react";
import { isBefore, addMonths } from "date-fns";
import { useTranslation } from "i18n";
import { useLocalStorage } from "usehooks-ts";
import NotificationBanner from "../NotificationBanner";
import { ReactComponent as InfoIconSvg } from "component-library/src/images/svg/icons/warning-icon-base.svg";

const CD_STUDIOS_BANNER_HIDDEN_EXP = "cd-st-b-hidden-exp";
const CD_STUDIOS_MONTH_EXP = 2;

const CdStudiosBanner = () => {
  const { t } = useTranslation();
  const [bannerExpDate, saveBannerExpDate] = useLocalStorage<string>(
    CD_STUDIOS_BANNER_HIDDEN_EXP,
    ""
  );

  const isBannerDismissed =
    bannerExpDate && isBefore(new Date(), new Date(bannerExpDate));

  const handleDismiss = (): void => {
    saveBannerExpDate(
      addMonths(new Date(), CD_STUDIOS_MONTH_EXP).toISOString()
    );
  };

  if (isBannerDismissed) {
    return null;
  }

  return (
    <NotificationBanner
      wrapperClassNames="bg-color-neutral-four"
      messageHtml={t("casting:home.banner.studios.message", {
        className: "c-my-account-page__notification-area__message_description",
      })}
      buttons={[
        {
          title: t("common:button.label.dismiss"),
          href: "##",
          text: t("common:button.label.dismiss"),
          type: "secondary",
          onClick: handleDismiss,
        },
        {
          title: t("common:button.label.findOutMore"),
          href: "https://www.spotlight.com/rooms-and-studios/studios",
          target: "_blank",
          text: t("common:button.label.findOutMore"),
        },
      ]}
      icon={
        <InfoIconSvg
          width={24}
          height={24}
          className="mr-2 text-color-brand-one"
        />
      }
    />
  );
};

export default CdStudiosBanner;
